import { Language, RegionType } from "graphql/generated";

export const checkCountry = (countries: RegionType[]): boolean =>
  countries.includes(process.env.NEXT_PUBLIC_COUNTRY as RegionType);

export const getDefaultLocale = (): Language => {
  if (checkCountry([RegionType.Jp])) {
    return Language.Ja;
  }

  return Language.En;
};
